import React from 'react';
// import AboutSection from '../AboutPage/AboutSection';
import { useParams } from 'react-router-dom';
import { postdata } from '../DUMMYDATA/DUMMYDATA';

const BlogDetail = () => {
    const { blogId } = useParams();
    const selectedPost = postdata.find(post => post.id === parseInt(blogId));

    if (!selectedPost) {
        return <div>Post not found</div>;
    }

    const { head,img, first, quots, second } = selectedPost;
    // const commentCount = comments.length;

  return (
    <section className='my-10'>  
        <div className='pt-[112px]'>
            <div className='md:mx-[174px] px-4'>
                <h2 className='mb-[41px] text-[24px] leading-7 font-bold relative pb-[12px] text-tertary2 tracking-[2px]'>{head} </h2>
                <p className='mb-[41px] leading-[32px] text-[18px] text-tertary2'>
                    {first}
                </p>
                <div className='mb-[41px]'>
                    <img src={img} alt="blog images" />
                </div>
                <blockquote className="text-[18px] leading-[32px] px-[22px] pt-[11px] pb-[5px] mb-[37px] border-l-2 border-[#c99035]">
                    <p>{quots} </p>
                    
                </blockquote>
                <div className='leading-[32px] text-base'>
                    <p className='mb-[41px] leading-[32px] text-[18px]'>
                        {second}
                    </p>
                    
                </div>
                <hr />
                
               
            </div>
        </div>
        
    </section>
  )
}

export default BlogDetail